import React from 'react';
import styled from 'styled-components';
import { createLocalScaleFunction } from '../../util/functions';
import { Heading } from '../../util/typography';

import SafetyList from './SafetyList';
import IndicationsList from './IndicationsList';
import { NAVIGATION_BREAKPOINT } from '../../constants/layout';
import Indications from './Indications';

const bp = NAVIGATION_BREAKPOINT;

export const Container = styled.div`
    height: 100%;
    max-width: 1032px;
    padding: 60px;
    margin: 0 auto 0;

    display: grid;
    column-gap: 40px;
    // grid-template-columns: ${({qsub}) => qsub ? '1fr 1fr' : '1fr'};
    grid-template-columns: 1fr;
    // grid-template-columns: 1fr 1fr;

    // grid-template-areas: ${({qsub}) => qsub ? '"div1 div2" "div3 div3"' : '"div1 div1" "div2 div2"'};
    grid-template-areas: "div1" "div2";
    // grid-template-areas: "div1 div2" "div3 div3";



    > section {
    &:first-child{
    grid-area: div1;
    & > header {
    height: ${({qsub}) => qsub && '64px'};
        }
    }

    &:nth-child(2){
    grid-area: div2;
    }

    &:nth-child(3){
    grid-area: div3;
    }

    &
        > header {
            margin-bottom: 20px;
        }
    }

    @media (max-width: ${bp}){

    grid-template-columns: 1fr;
    grid-template-columns: 100%;
    // grid-template-areas:
    //   "div1"
    //   "div2"
    //   "div3";
    gap: 0px;
    padding: 40px 20px;
    margin: 0 auto 0;
    > section:first-child > header{
    height: auto;
    }

    > section {
     & >header {
     margin-bottom: 10px;
     }}
      * {
        width: 100%;
        word-wrap:break-word;
     }
    }
`;

function IndicationAndSafetyPage({ inline_indications_ref, indicationId, safetyDataOverride, qsub }) {

    return (
        <Container qsub={qsub}>
            
           {/* {!qsub ? 
           <section>
                <header>
                    <Heading.H4 as='h2'>Selected Indications for KEYTRUDA® (pembrolizumab)</Heading.H4>
                </header>
                <div>
                    <IndicationsList indicationId={indicationId} />
                </div>
            </section> : 
            <section>
                <header>
                    <Heading.H4 as='h2'>Selected Indications for KEYTRUDA® (pembrolizumab) and KEYTRUDA QLEX™ (pembrolizumab and berahyaluronidase alfa-pmph)</Heading.H4>
                </header>
                <div>
                    <QSubIndicationList />
                </div>
            </section>} */}
           {/* <section>
                <header>
                    <Heading.H4 as='h2'>Selected Indications for KEYTRUDA® (pembrolizumab)</Heading.H4>
                </header>
                <div>
                    <IndicationsList indicationId={indicationId} />
                </div>
            </section>  */}
            <section>
                <header>
                    <Heading.H4 as='h2'>Selected Indications for KEYTRUDA® (pembrolizumab) and KEYTRUDA QLEX™ (pembrolizumab and berahyaluronidase alfa-pmph)</Heading.H4>
                </header>
                <div>
                    <IndicationsList indicationId={indicationId}/>
                </div>
            </section>
            {/* <Indications indicationId={indicationId} /> */}
            <section>
                <header ref={inline_indications_ref}>
                    <Heading.H4 as='h2'>Selected Safety Information</Heading.H4>
                </header>
                <div>
                    <SafetyList safetyDataOverride={safetyDataOverride} qsub={qsub} />
                </div>
            </section>
        </Container>
    );
}

export default IndicationAndSafetyPage;
